import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import StatusDot, { StatusStyle } from '../Status/StatusDot';
import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { Checkbox, Label } from '../Form';
import { Box } from 'rebass';
import { useMutation } from '@apollo/client';
import { ServiceAddress } from './WaterServiceDetail';
import { gql } from '@/modes/waterSupplier/gql';
import RequirePerms from '../RequirePerms';

const UPDATE_SEND_NOTICES = gql(`
  mutation SetServiceAddressSendNotices($id: ID!, $sendNotices: Boolean!) {
    setServiceAddressSendNotices(
      serviceAddressId: $id
      sendNotices: $sendNotices
    ) {
      id
      sendNotices
    }
  }
`);

const columns: Column[] = [
  {
    header: 'Status',
    id: 'customer.status',
    accessor: (row: ServiceAddress) => {
      let style: StatusStyle = 'default';
      if (row.active && row.customer.status === 'ACTIVE') {
        style = 'success';
      } else if (!row.active || row.customer.status === 'INACTIVE') {
        style = 'error';
      }

      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (row: ServiceAddress): string => {
      return constantToLabel(row.customer.status);
    },
    width: 70,
  },
  {
    header: 'Name',
    accessor: 'customer.profile.name',
    width: 200,
  },
  {
    header: 'Account',
    accessor: 'customer.accountNumber',
    width: 120,
  },
  {
    header: 'Role',
    accessor: 'customerRole',
    width: 150,
  },
  {
    header: 'Send Notices',
    id: 'sendNotices',
    accessor: (row: ServiceAddress) => {
      const [setServiceAddressSendNotices] = useMutation(UPDATE_SEND_NOTICES);

      const handleSendNoticesChange = () => {
        setServiceAddressSendNotices({
          variables: { id: row.id, sendNotices: !row.sendNotices },
        });
      };

      return (
        <Box onClick={(e) => e.stopPropagation()}>
          {row.active && row.customer.status !== 'INACTIVE' && (
            <Label variant="forms.label">
              <RequirePerms customers="UPDATE">
                <Checkbox
                  variant="forms.checkbox"
                  checked={row.sendNotices}
                  onChange={handleSendNoticesChange}
                />
              </RequirePerms>
              Yes
            </Label>
          )}
        </Box>
      );
    },
    stringAccessor: (row: any): string => {
      return constantToLabel(row.sendNotices);
    },
    width: 110,
  },
];

export default columns;
